<template>
  <div v-if="error" class="validation-error">
    {{ error.join(", ") }}
  </div>
</template>

<script>
export default {
  name: "ValidationError",
  props: {
    error: {
      type: String,
      required: true,
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/app/components/ValidationError.vue